export module PerformanceUtil {

  /**
   * GPUパフォーマンス判定用
   */
  export function checkGPU(): { [key: string]: string } {
    const result: { [key: string]: string } = {
      vendor: null,
      renderer: null,
      gl_version: null,
      gl_sl_version: null,
      max_texture_size: null,
    };
    const canvas: HTMLCanvasElement = document.createElement('canvas');
    let gl: any;

    try {
      gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    } catch (e) {
      return null;
    }

    if (gl) {
      const debugInfo: any = gl.getExtension('WEBGL_debug_renderer_info');
      result.vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
      result.renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
      result.gl_version = gl.getParameter(gl.VERSION);
      result.gl_sl_version = gl.getParameter(gl.SHADING_LANGUAGE_VERSION);
      result.max_texture_size = gl.getParameter(gl.MAX_TEXTURE_SIZE); //  (0 or 1024 - 16384)
    }

    return result;
  }

  /**
   * 負荷テスト用素数判定関数
   */
  export function isPrimeNum(num: number): boolean {
    let cnt: number = 0;
    const numbersArray: number[] = [];
    if (Number.isNaN(num)) {
      throw new TypeError();
    }
    for (let i = 0; i <= num; i += 1) {
      numbersArray[i] = i;
    }
    for (let i = 0; i < numbersArray.length; i += 1) {
      if (i !== 0) {
        if ((num % numbersArray[i]) === 0) {
          cnt += 1;
        }
      }
    }
    return cnt === 2;
  }

}
